import { render } from "./chooseChain.vue?vue&type=template&id=331261c0&scoped=true&lang=pug"
import script from "./chooseChain.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseChain.vue?vue&type=script&setup=true&lang=js"

import "./chooseChain.vue?vue&type=style&index=0&id=331261c0&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331261c0"]])

export default __exports__